"use client";
import Link from "next/link";
import log2 from "../../../public/updated-home/logo/Logo_Footer.svg";
// import logo from "../../../public/updated-home/logo/Logo_Footer.svg";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaPhoneAlt,
  FaPinterest,
} from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import PaymentMethod from "../../../public/updated-home/footer/paymentmethod.svg";
import { FaXTwitter } from "react-icons/fa6";

import Image from "next/image";

const navigation = {
  solutions: [
    { name: "Orlando  Airport", href: "/airports/orlando-airport-car-service" },
    {
      name: "Dallas Executive Airport",
      href: "/airports/dallas-executive-airport-car-service",
    },
    {
      name: "LaGuardia Airport",
      href: "/airports/lga-airport-car-service",
    },
    {
      name: "San Jose Airport",
      href: "/airports/san-jose-airport-car-service",
    },
    {
      name: "View All",
      href: "/airports",
    },
  ],
  cities: [
    {
      name: "New York City",
      herf: "/locations/new-york-city-car-service",
    },
    {
      name: "Miami",
      herf: "/locations/car-service-miami",
    },
    {
      name: "Boston",
      herf: "/locations/boston-car-service",
    },
    {
      name: "Dallas",
      herf: "/locations/car-service-dallas",
    },
    {
      name: "View All",
      herf: "/locations",
    },
  ],
  services: [
    { name: "Airport Car Service", href: "/services/airport-car-service" },
    { name: "City to City Rides", href: "/services/city-to-city" },
    { name: "Chauffeur Service", href: "/services/chauffeur-service" },
    { name: "Hourly Hire", href: "/services/hourly-car-service" },
    { name: "Special Event", href: "/services/special-events" },
  ],
  contact: [
    {
      title: "+1 (888) 346-9886",
      href: "tel:+18883469886",
      icon: <FaPhoneAlt />,
    },
    {
      title: "contact@prestigeride.com",
      href: "mailto:contact@prestigeride.com",
      icon: <IoMail />,
    },
  ],
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/prestigeridelimo",
      icon: <FaFacebook />,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/prestigerideservices/",
      icon: <FaInstagram />,
    },
    {
      name: "X",
      href: "https://twitter.com/PrestigeRide",
      icon: <FaXTwitter />,
    },
    {
      name: "X",
      href: "https://www.pinterest.com/prestigerideservices/",
      icon: <FaPinterest />,
    },
  ],
};

export default function Example() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      className="bg-[#2b3252] text-white"
      aria-labelledby="footer-heading"
    >
      <p id="footer-heading" className="sr-only">
        Footer
      </p>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-12">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-6">
            <div className="flex justify-center sm:justify-center md:justify-center lg:justify-start">
              <span className="sr-only">Your Company</span>
              <Link href="/" onClick={scrollTop}>
                <Image
                  className="h-6 w-auto"
                  src={log2}
                  alt="Prestige Ride logo"
                  title="Prestige Ride logo"
                />
              </Link>
            </div>
            <p className="text-md leading-6 text-gray-100">
              Your premier car service provider across the United State. Our
              fleet provides a top-tier, tailored travel experience that is both
              comfortable and professional. Discover the difference with
              Prestige Ride — where every journey is a statement. Join us to
              redefine your travel expectations.
            </p>
            <div className="flex lg:justify-start justify-center">
              <Link href={"/"}>
                <button
                  onClick={scrollTop}
                  className="border border-white hover:bg-[#d5af34] text-white px-3 py-2 rounded"
                >
                  Book Now
                </button>
              </Link>
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-4 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-4">
              <div className="">
                <Link href={"/locations"}>
                  <p className="text-xl font-semibold text-[#d5af34]">
                    TOP CITIES
                  </p>
                </Link>
                <ul role="list" className="mt-6 space-y-2">
                  {navigation.cities.map((item, i) => (
                    <li key={i}>
                      <a
                        href={item.herf}
                        className="text-md inline-block text-gray-100"
                      >
                        {item.name}
                        <div className="hoverLine"></div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0 ">
                <Link href={"/airports"}>
                  <p className="text-xl font-semibold text-[#d5af34]">
                    TOP AIRPORTS
                  </p>
                </Link>
                <ul role="list" className="mt-6 space-y-2">
                  {navigation.solutions.map((item, i) => (
                    <li key={i}>
                      <a
                        href={item.href}
                        className="text-md inline-block text-gray-100"
                      >
                        {item.name}

                        <div className="hoverLine"></div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-4 ">
              <div className="">
                <p className="text-xl font-semibold text-[#d5af34]">SERVICES</p>
                <ul role="list" className="mt-6 space-y-2">
                  {navigation.services.map((item, i) => (
                    <li key={i}>
                      <a
                        href={item.href}
                        className="text-md inline-block text-gray-100"
                      >
                        {item.name}
                        <div className="hoverLine"></div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0 ">
                <Link href={"/contact-us"}>
                  <p className="text-xl font-semibold text-[#d5af34]">
                    CONTACT DETAILS
                  </p>
                </Link>
                <ul role="list" className="mt-6 space-y-4">
                  <div className="space-y-3">
                    {navigation.contact.map((item, index) => (
                      <li key={index}>
                        <a
                          href={item.href}
                          className="text-md inline-block text-gray-100"
                        >
                          <span className="flex gap-2">
                            {" "}
                            <span className="pt-1">{item.icon}</span>
                            <span className="-">{item.title}</span>
                          </span>
                          <div className="hoverLine"></div>
                        </a>
                      </li>
                    ))}
                  </div>
                  <div className="flex space-x-4">
                    {navigation.social.map((item, i) => (
                      <a
                        target="blank"
                        key={i}
                        href={item.href}
                        className="text-white hover:text-gray-400 text-xl"
                      >
                        {item.icon}
                      </a>
                    ))}
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 flex lg:flex-row flex-col-reverse justify-between border-t border-white/10 pt-8 sm:mt-10 ">
          <div className="flex items-center lg:justify-start justify-center">
            <p className="text-md text-gray-100">
              &copy; 2025 Prestige Ride, Inc. All rights reserved.
            </p>
          </div>
          <div className="flex lg:flex-row flex-col-reverse items-center space-x-4">
            <div className="flex space-x-2">
              <li className="text-md list-none  text-gray-100">
                <Link href={"/cancellation-and-refund-policy"}>
                  Cancellation Policy
                </Link>
                <div className="hoverLine"></div>
              </li>
              <p className="text-md text-gray-100">|</p>

              <li className="text-md list-none  text-gray-100">
                <Link href={"/terms-and-condition"}>Terms & Conditions</Link>
                <div className="hoverLine"></div>
              </li>
              <p className="text-md text-gray-100">|</p>

              <li className="text-md list-none  text-gray-100">
                <Link href={"/privacy-and-cookies-policy"}>
                  Privacy and Cookies
                </Link>
                <div className="hoverLine"></div>
              </li>
            </div>

            <Image
              src={PaymentMethod}
              alt="payment method"
              title="payment method"
              className="mb-3 "
              width={172}
              height={27}
              priority={true}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
